import { render, staticRenderFns } from "./knockKnockJoke.vue?vue&type=template&id=7b43a0c3&scoped=true"
import script from "./knockKnockJoke.vue?vue&type=script&lang=js"
export * from "./knockKnockJoke.vue?vue&type=script&lang=js"
import style0 from "./knockKnockJoke.vue?vue&type=style&index=0&id=7b43a0c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b43a0c3",
  null
  
)

export default component.exports